import parameterTypesApi from '@/api/parameterTypes';


const state = {
  parameterTypes: [],
};


export const getters = {

  formattedParameterTypes: state =>
    state.parameterTypes.map(type => ({
      label: type.name,
      value: type.parameterTypeId,
    })),

  formattedParameter: state => (ParameterTypeId) => {
    let name = '';
    for (let i = 0; i < state.parameterTypes.length; i += 1) {
      if (ParameterTypeId === state.parameterTypes[i].parameterTypeId) {
        // eslint-disable-next-line
        name = state.parameterTypes[i].name;
      }
    }
    return name;
  },
};


export const actions = {
  getList({ commit }) {
    parameterTypesApi.getParameterTypes().then((data) => {
      commit('parameterTypes', data.parameterTypes);
    });
  },
};

export const mutations = {
  parameterTypes(state, payload) {
    state.parameterTypes = payload;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
